import React, { useState } from "react";
import { Box, Button, FormControl, IconButton, InputLabel, MenuItem, Select } from '@mui/material';
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";

/**
 * @author Sarthak Sharma.
 * @since 31-12-2023.
 * @description Audition Counter Section.
 */

const CounterCard = ({ title, total, changeAmount, changeColor = '#8D8D8E' }) => {
    return (
        <Box>
            <h3 className="text-white text-[14px] font-['Poppins-Light'] font-light">{title}</h3>
            <div className="flex gap-[2px] items-center">
                <h2 className="text-white text-[14px] font-['Poppins-Medium']">{total}</h2>
                {changeAmount <= 0 
                    ? <ArrowDropDown className="text-[#8D8D8E] text-3xl" />
                    : <ArrowDropUp className="text-[#8D8D8E] text-3xl" />
                }
                <h4 className="text-[12px] font-['Poppins-Medium']" style={{ color: changeColor }}>{Math.abs(changeAmount)}%</h4>
            </div>
        </Box>
    )
}


const CounterSection = (props) => {

    return (
        <Box className="max-w-[1567px] flex flex-wrap gap-y-[1px] gap-[0.1%] w-full bg-[#000000] rounded-[12px] overflow-hidden">
            <Box className="bg-[#1F1F25] job-filter px-5 py-3 flex justify-center items-center">
                <FormControl className="no-border" variant="standard" size="small">
                    <Select
                        // value={age}
                        defaultValue={10}
                        label=""
                        readOnly
                        className="text-white"
                        sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px'}}
                        MenuProps={{ className: 'dark' }}
                        // onChange={handleChange}
                    >
                        <MenuItem sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px'}} value={10}>7 days</MenuItem>
                        <MenuItem sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px'}} value={20}>14 days</MenuItem>
                        <MenuItem sx={{ fontFamily: 'Poppins-Regular', fontSize: '14px'}} value={30}>30 days</MenuItem>
                    </Select>
                </FormControl>
            </Box>
            <Box className="bg-[#1F1F25] job-card px-5 py-3">
                <CounterCard
                    title={'Auditions'}
                    total={12}
                    changeAmount={2}
                />
            </Box>
            <Box className="bg-[#1F1F25] job-card px-5 py-3">
                <CounterCard
                    title={'2nd Audition'}
                    total={6}
                    changeAmount={13}
                    changeColor="#03AB92"
                />
            </Box>
            <Box className="bg-[#1F1F25] job-card px-5 py-3">
                <CounterCard
                    title={'Archived Auditions'}
                    total={16}
                    changeAmount={0}
                />
            </Box>
            <Box className="bg-[#1F1F25] job-card px-5 py-3">
                <CounterCard
                    title={'Closed Auditions'}
                    total={6}
                    changeAmount={0}
                />
            </Box>
            <Box className="bg-[#1F1F25] job-card px-5 py-3">
                <CounterCard
                    title={'Premium Auditions'}
                    total={6}
                    changeAmount={0}
                    changeColor="#03AB92"
                />
            </Box>
        </Box>
    );

}

export default CounterSection;